import { graphql } from "gatsby"
import React, { useEffect } from "react"
import SEO from "../components/shared/Seo"
import Seo from "../components/seo"
import Hero from "../components/Hero/Hero"
import { Grid } from "swiper"
import SectionGrid from "../components/Grid/SectionGrid"
import SectionFeatureGeneric from "../components/SectionFeatureGeneric/SectionFeatureGeneric"
import SectionFeature from "../components/SectionFeature/SectionFeature"
import { Video } from "../components/Video/media"
import { PageListing } from "../components/PageListing/PageListing"
import { Brand } from "../components/Brand/brand"
import TimelineContainer from "../components/Timeline/TimelineContainer"
import {useUrl} from '../hooks/layout/useUrl'
const GenericPage = ({
  location,
  pageContext,
  data: {
    contentfulEkaterraGenericPage: {
      title,
      slug,
      node_locale,
      seoTitle,
      seoDescription,
      thumbnailTitle,
      content,
    },
  },
}) => {
  const lang = useUrl()
  const sustainabilityScroll = e => {
    e.preventDefault()
    window.scrollTo({
      top: document.querySelector(".Sustainability").offsetTop - 120,
      behavior: "smooth",
    })
  }
  useEffect(() => {
    if (document.querySelector("a[href$='sustainability-section']")) {
      document
        .querySelector("a[href$='sustainability-section']")
        .addEventListener("click", sustainabilityScroll)
    }
    return () => {
      if (document.querySelector("a[href$='sustainability-section']")) {
        document
          .querySelector("a[href$='sustainability-section']")
          .removeEventListener("click", sustainabilityScroll)
      }
    }
  }, [])
  
  const innovationScroll = e => {
    e.preventDefault()
    window.scrollTo({
      top: document.querySelector(".Innovation").offsetTop - 120,
      behavior: "smooth",
    })
  }
  useEffect(() => {
    if (document.querySelector("a[href$='innovation-section']")) {
      document
        .querySelector("a[href$='innovation-section']")
        .addEventListener("click", innovationScroll)
    }
    return () => {
      if (document.querySelector("a[href$='innovation-section']")) {
        document
          .querySelector("a[href$='innovation-section']")
          .removeEventListener("click", innovationScroll)
      }
    }
  }, [])

  const certificationScroll = e => {
    e.preventDefault()
    window.scrollTo({
      top: document.querySelector(".Certification").offsetTop -120,
      behavior: "smooth",
    })
  }
  useEffect(() => {
    if (document.querySelector("a[href$='certification-section']")) {
      document
        .querySelector("a[href$='certification-section']")
        .addEventListener("click", certificationScroll)
    }
    return () => {
      if (document.querySelector("a[href$='certification-section']")) {
        document
          .querySelector("a[href$='certification-section']")
          .removeEventListener("click", certificationScroll)
      }
    }
  }, [])
  return (
    <>
      <Seo
        title={seoTitle}
        description={seoDescription && seoDescription.seoDescription}
        node_locale={node_locale}
        lang = {lang}
      />
      {/* <Hero data ={{image}}/> */}
      {content.map((section: any, id: number) => {
        switch (section.__typename) {
          case "ContentfulSectionComponentHero":
            return <Hero data={section} key={id} />
          case "ContentfulComponentFeature":
            return (
              <div className={section.name}> 
                <SectionFeatureGeneric data={section} key={id} />
              </div>
            )
          case "ContentfulEkaterraSection":
            return <SectionGrid data={section} key={id} />
          case "ContentfulComponentMedia":
            return <Video data={section} key={id} />
          case "ContentfulComponentMenuGroup":
            return <PageListing data={section} key={id} />
          case "ContentfulEkaterraSubSection":
            return <Brand data={section} key={id} />
          default:
            return null
        }
      })}
      {slug === "purpose-and-sustainability/story" && <TimelineContainer />}
    </>
  )
}
export const GenericPageQuery = graphql`
  query EkaterraGenericPage($id: String!) {
    contentfulEkaterraGenericPage(id: { eq: $id }) {
      name
      node_locale
      seoTitle
      seoDescription {
        seoDescription
      }
      slug
      title
      thumbnailTitle
      content {
        __typename
        ... on ContentfulSectionComponentHero {
          id
          name
          title
          alignment
          description {
            raw
          }
          image {
            fluid{
                ...GatsbyContentfulFluid_withWebp_noBase64
            }
            title
        }
        }
        ... on ContentfulComponentFeature {
          id
          name
          title
          headingLevel
          appearance
          descriptionAlignmentLeft
          alignment
          description {
            raw
          }
          images {
            fluid{
                ...GatsbyContentfulFluid_withWebp_noBase64
            }
            title
        }
          button {
            link
            title
            externalLink
          }
        }
        ... on ContentfulEkaterraSection {
          id
          appearances
          subSection {
            description {
              raw
            }
            title
          }
        }
        ... on ContentfulComponentMedia {
          name
          youTubeUrl
        }

        ... on ContentfulComponentMenuGroup {
          id
          menuItems {
            ... on ContentfulEkaterraArticlePage {
              name
              slug
              thumbnailTitle
              thumbnailImage {
                fluid{
                    ...GatsbyContentfulFluid_withWebp_noBase64
                }
                title
            }
              thumbnailDescription {
                thumbnailDescription
              }
            }
          }
        }
        ... on ContentfulEkaterraSubSection {
          id
          title
          headingLevel
          images {
            fluid(maxWidth: 1200, maxHeight: 400){
                ...GatsbyContentfulFluid_withWebp_noBase64
            }
            title
        }
          description {
            raw
          }
        }
      }
    }
  }
`
export default GenericPage
